"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useWindowSize_1 = __importDefault(require("./useWindowSize"));
var Components_1 = require("./Components");
var Functions_1 = require("./Functions");
var initialPosX = {
    value: 0,
    time: Date.now(),
};
var initialTouchPosX = {
    value: 0,
    speed: 0,
    time: 0,
};
/**
 * A hook that provides the slider's complete state and properties
 * @param sliderWrapperWidth Width of the sliderWrapper
 * @param trackRef Reference to the track
 * @param trackRef Reference to the trackWrapper
 * @param props props of the slider
 */
var useSliderState = function (sliderWrapperWidth, trackRef, trackWrapperRef, props) {
    /**
     * props are destructured here and renamed so they can be redeclared further down for use with evalBreakpoint().
     * If you add another prop also add it to evaluation of breakpoints further down
     */
    var _a = react_1.useMemo(function () { return props; }, [props]), 
    /* eslint-disable @typescript-eslint/no-unused-vars */
    sliderChildren = _a.children, _b = _a.activeSlide, activeSlideProp = _b === void 0 ? 0 : _b, afterMoveProp = _a.afterMove, _c = _a.arrows, arrowsProp = _c === void 0 ? false : _c, _d = _a.arrowsDistance, arrowsDistanceProp = _d === void 0 ? 10 : _d, _e = _a.arrowsOnHover, arrowsOnHoverProp = _e === void 0 ? false : _e, _f = _a.autoplay, autoplayProp = _f === void 0 ? false : _f, _g = _a.autoplayDirection, autoplayDirectionProp = _g === void 0 ? 'right' : _g, _h = _a.autoplaySpeed, autoplaySpeedProp = _h === void 0 ? 2500 : _h, _j = _a.background, backgroundProp = _j === void 0 ? 'transparent' : _j, _k = _a.deltaToScroll, deltaToScrollProp = _k === void 0 ? 25 : _k, customLinkPropsProp = _a.customLinkProps, _l = _a.dots, dotsProp = _l === void 0 ? false : _l, _m = _a.dotsColor, dotsColorProp = _m === void 0 ? '#e0e0e0' : _m, _o = _a.dotsColorInactive, dotsColorInactiveProp = _o === void 0 ? '#fff' : _o, _p = _a.dotsDistance, dotsDistanceProp = _p === void 0 ? 0 : _p, _q = _a.dotsSize, dotsSizeProp = _q === void 0 ? 14 : _q, _r = _a.framePadding, framePaddingProp = _r === void 0 ? 0 : _r, _s = _a.hasCardLayout, hasCardLayoutProp = _s === void 0 ? false : _s, headlineProp = _a.headline, _t = _a.infinite, infiniteProp = _t === void 0 ? false : _t, _u = _a.itemOverflow, itemOverflowProp = _u === void 0 ? false : _u, _v = _a.lazyLoad, lazyLoadProp = _v === void 0 ? false : _v, _w = _a.lazyLoadItemWidth, lazyLoadItemWidthProp = _w === void 0 ? 200 : _w, _x = _a.lazyLoadThreshold, lazyLoadThresholdProp = _x === void 0 ? 500 : _x, _y = _a.nextArrow, nextArrowProp = _y === void 0 ? react_1.default.createElement(Components_1.ScrollButton, { right: true }) : _y, _z = _a.pauseOnHover, pauseOnHoverProp = _z === void 0 ? true : _z, _0 = _a.prevArrow, prevArrowProp = _0 === void 0 ? react_1.default.createElement(Components_1.ScrollButton, null) : _0, _1 = _a.progressBar, progressBarProp = _1 === void 0 ? false : _1, _2 = _a.progressBarColor, progressBarColorProp = _2 === void 0 ? '#e0e0e0' : _2, _3 = _a.progressBarDistance, progressBarDistanceProp = _3 === void 0 ? 0 : _3, _4 = _a.progressBarHeight, progressBarHeightProp = _4 === void 0 ? 5 : _4, _5 = _a.scrollStepwise, scrollStepwiseProp = _5 === void 0 ? false : _5, _6 = _a.slideGap, slideGapProp = _6 === void 0 ? 0 : _6, _7 = _a.sliderPaddingBottom, sliderPaddingBottomProp = _7 === void 0 ? 0 : _7, _8 = _a.slidesToScroll, slidesToScrollProp = _8 === void 0 ? 1 : _8, _9 = _a.slidesToShow, slidesToShowProp = _9 === void 0 ? 1 : _9, _10 = _a.snapping, snappingProp = _10 === void 0 ? true : _10, _11 = _a.speed, speedProp = _11 === void 0 ? 500 : _11, _12 = _a.touchMove, touchMoveProp = _12 === void 0 ? true : _12, _13 = _a.variableWidth, variableWidthProp = _13 === void 0 ? false : _13, responsive = _a.responsive;
    var windowSize = useWindowSize_1.default();
    var _14 = react_1.useState(0), sliderWidth = _14[0], setSliderWidth = _14[1];
    var _15 = react_1.useState(0), trackWidth = _15[0], setTrackWidth = _15[1];
    var _16 = react_1.useState(0), prevTrackWidth = _16[0], setPrevTrackWidth = _16[1];
    var sliderItemsCount = react_1.default.Children.count(sliderChildren);
    var _17 = react_1.useState(sliderItemsCount), prevSliderItemsCount = _17[0], setPrevSliderItemsCount = _17[1];
    var _18 = react_1.useState(), prevActiveSlide = _18[0], setPrevActiveSlide = _18[1];
    /** Array of visible sliderItems' ids. An entry looks like `sliderItem-${id}` */
    var _19 = react_1.useState([]), loadedSliderItems = _19[0], setLoadedSliderItems = _19[1];
    var _20 = react_1.useState(null), touchActive = _20[0], setTouchActive = _20[1];
    var _21 = react_1.useState(false), trackIsMoving = _21[0], setTrackIsMoving = _21[1];
    var _22 = react_1.useState(0), currentScrollDistance = _22[0], setCurrentScrollDistance = _22[1];
    var _23 = react_1.useState(false), dragActive = _23[0], setDragActive = _23[1];
    var _24 = react_1.useState(initialPosX), posX = _24[0], setPosX = _24[1];
    /** Cache to keep the original start position at scroll start */
    var _25 = react_1.useState(initialPosX), startPosX = _25[0], setStartPosX = _25[1];
    /** if infinite === true this is the count of extra to load items for start&end */
    var _26 = react_1.useState(0), extraItemsForInfinite = _26[0], setExtraItemsForInfinite = _26[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _27 = react_1.useState(initialTouchPosX), touchPosX = _27[0], setTouchPosX = _27[1];
    var _28 = react_1.useState(null), scrollOvershootTime = _28[0], setScrollOvershootTime = _28[1];
    var _29 = react_1.useState(false), isHovering = _29[0], setIsHovering = _29[1];
    // Find matching breakpoint.
    var getMatchingBreakpoint = react_1.useCallback(function (width) { return responsive === null || responsive === void 0 ? void 0 : responsive
    // breakpoints can come from styleTypes or custom props.
    // Sorting so custom props will overwrite styleType breakpoint settings of breakpoints with the same width
    .sort(function (bp1, bp2) { return (bp1.breakpoint >= bp2.breakpoint ? 1 : -1); }).reduce(function (prevBp, currentBp) {
        return currentBp.breakpoint <= width
            ? {
                breakpoint: currentBp.breakpoint,
                settings: __assign(__assign({}, prevBp.settings), currentBp.settings),
            } // Values from correct breakpoint are added to smaller breakpoints to inherit those properties
            : prevBp;
    }, { breakpoint: -1, settings: {} }); }, [responsive]);
    var breakpoint = react_1.useMemo(function () { return getMatchingBreakpoint(sliderWidth); }, [sliderWidth]);
    /**
     * Every prop is checked if it exists on a matching breakpoint setting. If that's the case evalBreakpoint() takes that setting and assigns it to the "original" propName.
     * Otherwise the base-sliderSetting or default is used.
     */
    var evalBreakpoint = react_1.useCallback(function (parameterName) {
        return breakpoint && breakpoint.settings[parameterName] !== undefined
            ? breakpoint.settings[parameterName]
            : // eslint-disable-next-line no-eval
                eval(parameterName + "Prop");
    }, [breakpoint, props]);
    var propEvalDeps = [props, sliderWidth];
    /**
     * Evaluation of breakpoints for every prop
     */
    var activeSlide = react_1.useMemo(function () { return evalBreakpoint('activeSlide'); }, propEvalDeps);
    var afterMove = react_1.useMemo(function () { return evalBreakpoint('afterMove'); }, propEvalDeps);
    var arrows = react_1.useMemo(function () { return evalBreakpoint('arrows'); }, propEvalDeps);
    var arrowsDistance = react_1.useMemo(function () { return evalBreakpoint('arrowsDistance'); }, propEvalDeps);
    var arrowsOnHover = react_1.useMemo(function () { return evalBreakpoint('arrowsOnHover'); }, propEvalDeps);
    var autoplay = react_1.useMemo(function () { return evalBreakpoint('autoplay'); }, propEvalDeps);
    var autoplayDirection = react_1.useMemo(function () { return evalBreakpoint('autoplayDirection'); }, propEvalDeps);
    var autoplaySpeed = react_1.useMemo(function () { return evalBreakpoint('autoplaySpeed'); }, propEvalDeps);
    var background = react_1.useMemo(function () { return evalBreakpoint('background'); }, propEvalDeps);
    var customLinkProps = react_1.useMemo(function () { return evalBreakpoint('customLinkProps'); }, propEvalDeps);
    var deltaToScroll = react_1.useMemo(function () { return evalBreakpoint('deltaToScroll'); }, propEvalDeps);
    var dots = react_1.useMemo(function () { return evalBreakpoint('dots'); }, propEvalDeps);
    var dotsColor = react_1.useMemo(function () { return evalBreakpoint('dotsColor'); }, propEvalDeps);
    var dotsColorInactive = react_1.useMemo(function () { return evalBreakpoint('dotsColorInactive'); }, propEvalDeps);
    var dotsDistance = react_1.useMemo(function () { return evalBreakpoint('dotsDistance'); }, propEvalDeps);
    var dotsSize = react_1.useMemo(function () { return evalBreakpoint('dotsSize'); }, propEvalDeps);
    var framePadding = react_1.useMemo(function () { return evalBreakpoint('framePadding'); }, propEvalDeps);
    var hasCardLayout = react_1.useMemo(function () { return evalBreakpoint('hasCardLayout'); }, propEvalDeps);
    var headline = react_1.useMemo(function () { return evalBreakpoint('headline'); }, propEvalDeps);
    var infinite = react_1.useMemo(function () { return evalBreakpoint('infinite'); }, propEvalDeps);
    var itemOverflow = react_1.useMemo(function () { return evalBreakpoint('itemOverflow'); }, propEvalDeps);
    var lazyLoad = react_1.useMemo(function () { return evalBreakpoint('lazyLoad'); }, propEvalDeps);
    var lazyLoadItemWidth = react_1.useMemo(function () { return evalBreakpoint('lazyLoadItemWidth'); }, propEvalDeps);
    var lazyLoadThreshold = react_1.useMemo(function () { return evalBreakpoint('lazyLoadThreshold'); }, propEvalDeps);
    var nextArrow = react_1.useMemo(function () { return evalBreakpoint('nextArrow'); }, propEvalDeps);
    var pauseOnHover = react_1.useMemo(function () { return evalBreakpoint('pauseOnHover'); }, propEvalDeps);
    var prevArrow = react_1.useMemo(function () { return evalBreakpoint('prevArrow'); }, propEvalDeps);
    var progressBar = react_1.useMemo(function () { return evalBreakpoint('progressBar'); }, propEvalDeps);
    var progressBarHeight = react_1.useMemo(function () { return evalBreakpoint('progressBarHeight'); }, propEvalDeps);
    var progressBarColor = react_1.useMemo(function () { return evalBreakpoint('progressBarColor'); }, propEvalDeps);
    var progressBarDistance = react_1.useMemo(function () { return evalBreakpoint('progressBarDistance'); }, propEvalDeps);
    var scrollStepwise = react_1.useMemo(function () { return evalBreakpoint('scrollStepwise'); }, propEvalDeps);
    var slideGap = react_1.useMemo(function () { return evalBreakpoint('slideGap'); }, propEvalDeps);
    var sliderPaddingBottom = react_1.useMemo(function () { return evalBreakpoint('sliderPaddingBottom'); }, propEvalDeps);
    var slidesToScroll = react_1.useMemo(function () { return evalBreakpoint('slidesToScroll'); }, propEvalDeps);
    var slidesToShow = react_1.useMemo(function () { return evalBreakpoint('slidesToShow'); }, propEvalDeps);
    var snapping = react_1.useMemo(function () { return evalBreakpoint('snapping'); }, propEvalDeps);
    var speed = react_1.useMemo(function () { return evalBreakpoint('speed'); }, propEvalDeps);
    var touchMove = react_1.useMemo(function () { return evalBreakpoint('touchMove'); }, propEvalDeps);
    var variableWidth = react_1.useMemo(function () { return evalBreakpoint('variableWidth'); }, propEvalDeps);
    var sliderInnerWidth = sliderWidth - 2 * framePadding;
    var slideWidth = (sliderInnerWidth - slideGap) / slidesToShow;
    var scrollDistance = (slidesToScroll / slidesToShow) * (sliderInnerWidth - slideGap);
    var maxScrollPosRight = -trackWidth + sliderInnerWidth - slideGap;
    var frameSmallerThanTrack = trackWidth > sliderInnerWidth - slideGap;
    var extraInfiniteWidth = 2 * extraItemsForInfinite * slideWidth;
    var virtualTrackWidth = trackWidth - extraInfiniteWidth;
    var virtualMaxScrollPosRight = maxScrollPosRight + extraInfiniteWidth / 2;
    // Rounding calc errors
    var progress = Math.round(((posX.value + extraInfiniteWidth / 2) / (maxScrollPosRight + extraInfiniteWidth || 1)) *
        10000) / 10000 || 0;
    // Ref for overshoot setTimeout to be able to clear it when touching the slider while it still overshoots
    var overshootTimeout = react_1.useRef(0);
    var scrollTimeout = react_1.useRef(0);
    /**
     * jumps to new posX without transition animation
     * @param func function that calculates the desired new posX (oldNumber => newNumber)
     */
    var jumpToPosX = react_1.useCallback(function (numOrFunc, keepTouchActive) {
        // to prevent animation touchActive is set
        setTouchActive('jumpScroll');
        // posX and startPosX is set to have a starting point for stepwise scrolling, too
        setPosX(function (oldPosX) {
            var newPosX = {
                value: typeof numOrFunc === 'function' ? numOrFunc(oldPosX.value) : numOrFunc,
                time: Date.now(),
            };
            setStartPosX(newPosX);
            return newPosX;
        });
        // Has to be set in a timeout so it will be executed at the end of callstack ie after setting the new scrollPos
        setTimeout(function () {
            setTouchActive(keepTouchActive || null);
            // If no swipe takes place while jumping track won't move directly after so it can be disabled
            setTrackIsMoving(Boolean(keepTouchActive));
        }, 0);
    }, [setTouchActive, setPosX, setStartPosX]);
    var stopOvershooting = react_1.useCallback(function () {
        setScrollOvershootTime(null);
        setTouchPosX(function (oldTouchPosX) { return (__assign(__assign({}, oldTouchPosX), { speed: 0 })); });
    }, [sliderWidth]);
    /**
     * Actions that should happen after track movement; Called from activateTrackMoving()
     * @param newPosX Final posX after trackMoving
     */
    var finishTrackMoving = react_1.useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, newPosX = _b.newPosX, keepTouchActive = _b.keepTouchActive;
        setCurrentScrollDistance(0);
        var newPosXValue = typeof newPosX === 'number'
            ? newPosX
            : trackRef.current.getBoundingClientRect().left -
                trackWrapperRef.current.getBoundingClientRect().left -
                slideGap;
        // Infinite scrolling
        if (extraItemsForInfinite) {
            // jump when arriving the end
            if (Math.floor(newPosXValue) <= -trackWidth + slideWidth * extraItemsForInfinite) {
                jumpToPosX(trackWidth - slideWidth * 2 * extraItemsForInfinite + newPosXValue, keepTouchActive);
                return;
            }
            // jump when arriving the start
            if (Math.ceil(newPosXValue) >=
                -slideWidth * extraItemsForInfinite + sliderInnerWidth - slideGap) {
                jumpToPosX(-trackWidth + slideWidth * 2 * extraItemsForInfinite + newPosXValue, keepTouchActive);
                return;
            }
        }
        // Stopping overshoot
        setTrackIsMoving(false);
        setPosX({
            value: Functions_1.considerBoundaries(newPosXValue, maxScrollPosRight),
            time: Date.now(),
        });
        clearTimeout(scrollTimeout.current);
        clearTimeout(overshootTimeout.current);
        stopOvershooting();
    }, [trackWidth, slideWidth, extraItemsForInfinite]);
    /**
     * Sets trackIsMoving state = true and deactivates it after scrollTime, so dependent components know how long to be active
     * @param distance Distance that will be calculated to scrollTime
     * @param time scrollTime the movement will take
     */
    var activateTrackMoving = react_1.useCallback(function (_a) {
        var oldPosX = _a.oldPosX, newPosX = _a.newPosX, time = _a.time;
        var distance = Math.abs((newPosX || 0) - (oldPosX || newPosX || 0));
        clearTimeout(scrollTimeout.current);
        setTrackIsMoving(true);
        if (typeof oldPosX === 'number' && typeof newPosX === 'number') {
            setCurrentScrollDistance(distance);
        }
        scrollTimeout.current = window.setTimeout(function () {
            if (typeof newPosX === 'number')
                finishTrackMoving({ newPosX: newPosX });
        }, time || Functions_1.getScrollTime(distance || 0, speed));
    }, [trackWidth, sliderWidth, slideWidth, extraItemsForInfinite]);
    var scrollToPosX = react_1.useCallback(function (numOrFunc) {
        setPosX(function (oldPosX) {
            var newValue = Functions_1.considerBoundaries(Functions_1.considerSnapping(typeof numOrFunc === 'function' ? numOrFunc(oldPosX.value) : numOrFunc, snapping, variableWidth, virtualMaxScrollPosRight, slideWidth), maxScrollPosRight);
            activateTrackMoving({ newPosX: newValue, oldPosX: oldPosX.value });
            var newPosX = {
                value: newValue,
                time: Date.now(),
            };
            setStartPosX(newPosX);
            return newPosX;
        });
    }, [sliderWidth, maxScrollPosRight]);
    /**
     * Scrolls either from current position or from start position if scrollStepwise === true
     */
    var scroll = react_1.useCallback(function (direction) {
        scrollToPosX(function (oldPosXValue) {
            var startPosXValue = scrollStepwise ? startPosX.value : oldPosXValue;
            // To enable blockwise scrolling eg [012][345][6--]
            // The difference between the desired newPosX and the next block that will be overscrolled
            // is calculated - and then substracted from the desired newPosX to get the "blocklimited posX"
            // Leads to correct switching and no skipping of navigationDots
            var risesAboveRight = posX.value < virtualMaxScrollPosRight;
            var risesAboveLeft = posX.value > -extraInfiniteWidth / 2;
            var trackModulo = virtualTrackWidth - (risesAboveRight ? 0 : sliderInnerWidth - slideGap);
            if (risesAboveLeft)
                trackModulo = sliderInnerWidth - slideGap - scrollDistance;
            var diff = Math.round(100 *
                (((startPosXValue +
                    extraInfiniteWidth / 2 +
                    (direction === 'left' ? 1 : -1) * scrollDistance) %
                    (trackModulo || 2 * trackWidth)) % // If trackModulo === 0 prevent NaN-Error
                    scrollDistance)) / 100;
            var diffReal = Math.round(Math.abs(diff)) === Math.round(scrollDistance) ? 0 : diff;
            var actualDiff = diffReal < 0 ? scrollDistance + diffReal : diffReal;
            return direction === 'left'
                ? startPosXValue + scrollDistance - actualDiff
                : startPosXValue - scrollDistance - diffReal;
        });
    }, [trackWidth, slideWidth, startPosX, scrollStepwise, scrollToPosX]);
    var clickProgressDot = react_1.useCallback(function (dotIndex, dotsCount) {
        var rest = virtualTrackWidth % scrollDistance;
        // Calculation to choose correct position even in infinite mode
        var newPosX = -dotIndex * scrollDistance +
            (dotIndex === dotsCount - 1 && rest > 1 ? scrollDistance - rest : 0) -
            extraInfiniteWidth / 2;
        // To not overscroll last item on lastDotClick in infinite mode
        scrollToPosX(Functions_1.considerBoundaries(newPosX, maxScrollPosRight + extraInfiniteWidth / 2));
    }, [sliderInnerWidth, slideGap, scrollToPosX]);
    var setPosXInBoundaries = react_1.useCallback(function () {
        return setPosX(function (oldPosX) { return ({
            value: Functions_1.considerBoundaries(oldPosX.value, maxScrollPosRight),
            time: Date.now(),
        }); });
    }, [setPosX, maxScrollPosRight]);
    /**
     * Setting sliderWidth
     */
    react_1.useEffect(function () {
        // Has to have a minWidth so calculations can start
        setSliderWidth(sliderWrapperWidth || 1);
    }, [windowSize, sliderWrapperWidth]);
    /**
     * Add extraItems for infinite carousel if !variableWidth (calculations doesn't work with variableItems right now)
     * Sets the extraItemsForInfinite to default value -> 2 x the viewable elements, so a swipe at the edge will never show whitespace
     */
    react_1.useEffect(function () {
        if (sliderWidth > 1) {
            setExtraItemsForInfinite(infinite && !variableWidth ? 2 * Math.ceil(sliderWidth / slideWidth) : 0);
        }
    }, [infinite, sliderWidth, slideWidth, sliderItemsCount, variableWidth]);
    /**
     * If slider has been initialized listen to changes of children so trackWidth & posX can be reset if eg children got less
     */
    react_1.useEffect(function () {
        if (sliderWidth && trackRef.current) {
            // TrackWidth should be initialized with a minimal size at start to support variableWidth items
            var newTrackWidth_1 = Math.abs(variableWidth
                ? trackRef.current.offsetWidth
                : (sliderItemsCount + 2 * extraItemsForInfinite) * slideWidth) || 1;
            setTrackWidth(function (oldTrackWidth) {
                setPrevTrackWidth(oldTrackWidth || newTrackWidth_1);
                return newTrackWidth_1;
            });
            // Consider boundaries if slider got so wide while resizing that there's free space behind the last item
            setPosXInBoundaries();
        }
    }, [sliderWidth, slideWidth, sliderItemsCount, extraItemsForInfinite, loadedSliderItems]);
    /**
     * Syncing previous scrollPosition to current SliderWidth and slideWidth so same slide will be in view
     * Will happen on window resizing or when children get less
     * In its own useEffect because in the one dependent on windowSize new values are not available yet
     */
    react_1.useEffect(function () {
        // Aborts syncing if slider state should prevent that (not initialized, posX at start, sliderWidth too narrow)
        if (prevTrackWidth <= (sliderItemsCount - 1) * slideGap ||
            posX.value === 0 ||
            maxScrollPosRight >= 0)
            return;
        // Resizing the window should not affect variableWidth mode except if all lazyLoadedItems have already been loaded
        // or posX is too far on the right. Eg because of too narrow/wide lazyLoadSkeletonWidth
        if ((sliderItemsCount === prevSliderItemsCount &&
            loadedSliderItems.length === sliderItemsCount) ||
            posX.value < maxScrollPosRight) {
            setPosX(function (oldPosX) {
                var newPosXValue = (trackWidth / prevTrackWidth) * oldPosX.value;
                var syncedPosX = {
                    value: Functions_1.considerBoundaries(newPosXValue, maxScrollPosRight),
                    time: Date.now(),
                };
                // Also sync startPosX
                setStartPosX(syncedPosX);
                return syncedPosX;
            });
        }
        else if (sliderItemsCount < prevSliderItemsCount && posX.value < maxScrollPosRight) {
            setPosXInBoundaries();
        }
        if (prevSliderItemsCount !== sliderItemsCount)
            setPrevSliderItemsCount(sliderItemsCount);
    }, [trackWidth]);
    /**
     * Jump to the slide's position when activeSlide is changed / at start
     */
    react_1.useEffect(function () {
        if (
        // Slider is fully initialized
        sliderWidth > 1 &&
            slideWidth > 1 &&
            // If jump has already be executed
            prevActiveSlide !== activeSlide + extraItemsForInfinite &&
            // maxScrollPosRight && trackWidth have to be initialized
            maxScrollPosRight < 0 &&
            maxScrollPosRight <=
                -(extraItemsForInfinite + sliderItemsCount - slidesToShow) * slideWidth &&
            // If maxScrollPosRight changes because of added/removed sliderItems (-> activateTrackMoving is executed -> prevActiveSlide reset)
            sliderItemsCount === prevSliderItemsCount) {
            var selectedSlide = activeSlide + extraItemsForInfinite;
            scrollToPosX(-selectedSlide * slideWidth);
            setPrevActiveSlide(selectedSlide);
        }
    }, [activeSlide, sliderWidth, slideWidth, trackWidth, maxScrollPosRight, extraItemsForInfinite]);
    /**
     * Further movement after touch completed
     * ScrollStepwise or overshoot
     */
    react_1.useEffect(function () {
        // If slider has been initialized and touch action has finished
        // And if touch has been executed
        if (sliderWidth && trackWidth > 2 * slideGap && !touchActive) {
            var time = Date.now();
            var newPosXDesired = posX.value;
            var newPosXActual = Functions_1.considerBoundaries(Functions_1.considerSnapping(posX.value, snapping, variableWidth, virtualMaxScrollPosRight, slideWidth), maxScrollPosRight);
            if (scrollStepwise) {
                // If slide was moved by 25px or more next slide will be shown
                var deltaStartPos = startPosX.value - posX.value;
                if (Math.abs(deltaStartPos) >= deltaToScroll) {
                    if (deltaStartPos > 0) {
                        scroll('right');
                    }
                    else {
                        scroll('left');
                    }
                }
                else {
                    setPosX({
                        value: Functions_1.considerBoundaries(Functions_1.considerSnapping(startPosX.value, snapping, variableWidth, virtualMaxScrollPosRight, slideWidth), maxScrollPosRight),
                        time: Date.now(),
                    });
                }
            }
            else {
                var overshootDistance = 30 * (touchPosX.speed || 0) * (time - posX.time);
                // Overshoot after user has ended touchmove but doesn't keep his finger pressed on screen for longer than 50ms
                if (touchPosX.speed && Date.now() - posX.time <= 50) {
                    newPosXDesired = posX.value + overshootDistance;
                    newPosXActual = Functions_1.considerBoundaries(Functions_1.considerSnapping(newPosXDesired, snapping, variableWidth, virtualMaxScrollPosRight, slideWidth), maxScrollPosRight);
                    // If overshoot will go over an edge of the track reduce it / fit it to snapping
                    if (newPosXActual !== newPosXDesired) {
                        overshootDistance -= newPosXDesired - newPosXActual;
                    }
                    // Squareroot function to prevent long scrolls to take forever. Short distances should be affected less in relation.
                    var overshootTime = Math.sqrt(Math.abs(overshootDistance) * 1850);
                    setScrollOvershootTime(overshootTime);
                    activateTrackMoving({ newPosX: newPosXActual, time: overshootTime });
                    clearTimeout(overshootTimeout.current);
                    overshootTimeout.current = window.setTimeout(function () {
                        stopOvershooting();
                    }, overshootTime);
                }
                else {
                    // If !touchIsActive && no overshoot takes place
                    // activateTrackMoving with newPosX will check if trackModifications for infinite scroll should be executed
                    activateTrackMoving({ newPosX: newPosXActual });
                }
                setPosX({ value: newPosXActual, time: time });
            }
        }
    }, [touchActive]);
    var autoplayInterval = react_1.useRef(0);
    /**
     * starts autoplay
     */
    react_1.useEffect(function () {
        if (autoplay) {
            autoplayInterval.current = window.setInterval(function () {
                if (!trackIsMoving && !isHovering)
                    scroll(autoplayDirection);
            }, autoplaySpeed);
        }
        return function () { return clearTimeout(autoplayInterval.current); };
    }, [
        autoplay,
        autoplayDirection,
        autoplaySpeed,
        trackIsMoving,
        isHovering,
        startPosX,
        scrollToPosX,
        jumpToPosX,
        scroll,
    ]);
    /**
     * Function that is executed after each movement. It receives the current progress & active slide(s).
     * If on variableWidth mode it will provide progress only
     */
    react_1.useEffect(function () {
        if (sliderWidth > 1 && slideWidth > 1 && !trackIsMoving && typeof afterMove === 'function') {
            var visibleSlide_1 = (Math.round(((-posX.value - extraInfiniteWidth / 2) / (trackWidth - extraInfiniteWidth)) *
                sliderItemsCount) +
                2 * sliderItemsCount) %
                sliderItemsCount;
            var afterMoveFuncObj = __assign({ progress: progress }, (variableWidth
                ? {}
                : {
                    visibleSlide: visibleSlide_1,
                    visibleSlides: Array.from({ length: slidesToShow }, function (v, i) { return (visibleSlide_1 + i) % sliderItemsCount; }),
                }));
            afterMove(afterMoveFuncObj);
        }
    }, [trackIsMoving, slidesToShow, sliderItemsCount, afterMove]);
    return {
        arrows: arrows,
        arrowsDistance: arrowsDistance,
        arrowsOnHover: arrowsOnHover,
        background: background,
        clickProgressDot: clickProgressDot,
        currentScrollDistance: currentScrollDistance,
        customLinkProps: customLinkProps,
        dots: dots,
        dotsColor: dotsColor,
        dotsColorInactive: dotsColorInactive,
        dotsDistance: dotsDistance,
        dotsSize: dotsSize,
        dragActive: dragActive,
        extraItemsForInfinite: extraItemsForInfinite,
        finishTrackMoving: finishTrackMoving,
        framePadding: framePadding,
        frameSmallerThanTrack: frameSmallerThanTrack,
        hasCardLayout: hasCardLayout,
        headline: headline,
        infinite: infinite,
        isHovering: isHovering,
        itemOverflow: itemOverflow,
        jumpToPosX: jumpToPosX,
        lazyLoad: lazyLoad,
        lazyLoadItemWidth: lazyLoadItemWidth,
        lazyLoadThreshold: lazyLoadThreshold,
        maxScrollPosRight: maxScrollPosRight,
        nextArrow: nextArrow,
        pauseOnHover: pauseOnHover,
        posX: posX,
        prevArrow: prevArrow,
        progress: progress,
        progressBar: progressBar,
        progressBarColor: progressBarColor,
        progressBarDistance: progressBarDistance,
        progressBarHeight: progressBarHeight,
        scroll: scroll,
        scrollDistance: scrollDistance,
        scrollOvershootTime: scrollOvershootTime,
        scrollToPosX: scrollToPosX,
        setDragActive: setDragActive,
        setIsHovering: setIsHovering,
        setPosX: setPosX,
        setTouchActive: setTouchActive,
        setTouchPosX: setTouchPosX,
        setTrackIsMoving: setTrackIsMoving,
        setLoadedSliderItems: setLoadedSliderItems,
        slideGap: slideGap,
        sliderInnerWidth: sliderInnerWidth,
        sliderPaddingBottom: sliderPaddingBottom,
        sliderWidth: sliderWidth,
        speed: speed,
        touchActive: touchActive,
        touchMove: touchMove,
        touchPosX: touchPosX,
        trackIsMoving: trackIsMoving,
        trackWidth: trackWidth,
        variableWidth: variableWidth,
        loadedSliderItems: loadedSliderItems,
        virtualTrackWidth: virtualTrackWidth,
    };
};
exports.default = useSliderState;
//# sourceMappingURL=useSliderState.js.map